export const EXCLUDED_MUTATION_OPERATION_NAMES: string[] = [];
export const EXCLUDED_QUERY_OPERATION_NAMES: string[] = [];
